import { userActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {
  list: [],
  success: '',
  error: '',
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_ALL_SUCCESS: {
      const { users } = action.payload;
      return {
        ...state,
        list: users,
      };
    }

    case actionType.GET_SUCCESS: {
      return {
        ...state,
      };
    }

    case actionType.UPDATE_SUCCESS: {
      const { updatedUser, successMsg } = action.payload;
      const newList = state.list.map((user) => ((user.id === updatedUser.id) ? updatedUser : user));

      return {
        ...state,
        list: newList,
        success: successMsg,
      };
    }

    case actionType.CREATE_SUCCESS: {
      const { user, successMsg } = action.payload;
      return {
        ...state,
        list: [...state.list, user],
        success: successMsg,

      };
    }

    case actionType.DELETE_SUCCESS: {
      const { id, successMsg } = action.payload;
      const filteredList = state.list.filter((user) => user.id !== id);

      return {
        ...state,
        list: filteredList,
        success: successMsg,
      };
    }

    case actionType.FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        error
      };
    }

    case actionType.CLEAR_MESSAGES: {
      return {
        ...state,
        success: '',
        error: ''
      };
    }

    default: {
      return state;
    }
  }
};

export default userReducer;
